<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCommentMultiple } from "@mdi/js";
export default {
  name: "MdiCommentMultiple",
  data() {
    return {
      svgPath: mdiCommentMultiple,
    };
  },
};
</script>
